import { useEffect } from 'react';
import { useTakeoverContext } from '../components/_app/TakeoverProvider/TakeoverContext';
import { ACHIEVEMENT_EARNED_EVENT, AchievementEarnedEventDetail } from '../utils/achievementPolling';
import { TakeoverId } from './useTakeover';

export const useAchievementTakeover = (): void => {
  const { openTakeover } = useTakeoverContext();

  useEffect(() => {
    const handleAchievementEarned = (event: CustomEvent<AchievementEarnedEventDetail>) => {
      const { achievements } = event.detail;

      openTakeover(TakeoverId.BADGE_EARNED, {
        achievements,
      });
    };

    window.addEventListener(ACHIEVEMENT_EARNED_EVENT, handleAchievementEarned as EventListener);

    return () => {
      window.removeEventListener(ACHIEVEMENT_EARNED_EVENT, handleAchievementEarned as EventListener);
    };
  }, [openTakeover]);
};
